import { LuChevronDown } from 'react-icons/lu';
import { ImageWithFallback } from './figma/image-with-fallback';
import { motion } from "framer-motion";

export function ExposureSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-16"
          style={{ fontSize: '2.25rem', fontWeight: 800, lineHeight: 1.3 }}
        >
          하루 <span className="text-blue-600">1개</span>의<br />
          이벤트만 올려도
        </motion.h1>
        
        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl overflow-hidden shadow-xl mb-6"
        >
          <div className="relative w-full h-48">
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1562577308-9e66f0c65ce5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtYXJrZXRpbmclMjBleHBvc3VyZSUyMGJ1c2luZXNzfGVufDF8fHx8MTc2NTk2ODc5MXww&ixlib=rb-4.1.0&q=80&w=1080"
              alt="노출"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent" />
          </div>
          
          <div className="p-8">
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8">
              <div className="text-center">
                <p className="text-white/90 mb-4" style={{ fontSize: '1.125rem', fontWeight: 600 }}>
                  👉 매장을
                </p>
                <div className="text-white mb-3" style={{ fontSize: '4rem', fontWeight: 900, lineHeight: 1 }}>
                  수천 명
                </div>
                <p className="text-white/90" style={{ fontSize: '1.125rem', fontWeight: 600 }}>
                  의 동네 고객에게 노출
                </p>
              </div>
            </div>
          </div>
        </motion.div>
        
        <motion.div variants={itemVariants}>
          <LuChevronDown className="w-6 h-6 text-gray-400 animate-bounce" />
        </motion.div>
      </motion.div>
    </section>
  );
}
